export default "__VITE_ASSET__CgK_QWkW__"